const isOnSimCreateProxyCompleted = (obj) => {
  return typeof obj?.onSimCreateProxyCompleted === "function";
};
export {
  isOnSimCreateProxyCompleted
};
//# sourceMappingURL=OnSimCreateCompleted.js.map
